(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-variants-color"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('color-card-pages')) {
    customElements.define('color-card-pages', class extends HTMLElement {
      connectedCallback() {
        this.style.display = 'block';
        this.initializePages();
        if (!this.querySelector('[data-color-pages]')) {
          this.observer = new MutationObserver(() => this.initializePages());
          this.observer.observe(this, { childList: true, subtree: true });
        }
      }

      disconnectedCallback() {
        this.observer?.disconnect();
      }

      initializePages() {
        const navigation = this.querySelector('[data-color-pages]');
        const grid = this.querySelector('.product-list__inner');
        if (!navigation || !grid) return;
        this.observer?.disconnect();
        const cards = Array.from(grid.children);
        const perPage = Math.max(1, Number(this.getAttribute('per-page')) || 24);
        const pages = Math.ceil(cards.length / perPage);
        navigation.replaceChildren();
        navigation.hidden = pages <= 1;
        const buttons = [];
        const showPage = (page) => {
          cards.forEach((card, index) => {
            card.hidden = index < (page - 1) * perPage || index >= page * perPage;
          });
          buttons.forEach((button, index) => {
            if (index + 1 === page) button.setAttribute('aria-current', 'page');
            else button.removeAttribute('aria-current');
          });
        };
        for (let page = 1; page <= pages; page++) {
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'pagination__nav-item heading heading--small';
          button.textContent = String(page);
          button.addEventListener('click', () => {
            showPage(page);
            grid.scrollIntoView({ block: 'start', behavior: 'smooth' });
          });
          buttons.push(button);
          navigation.append(button);
        }
        showPage(1);
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
